import React, { Fragment, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './WriteNews.scss';
import Icon from '../../components/Icon/Icon';
import NewsEditor from '../../components/NewsEditor/NewsEditor';
import { fetchUpdateNews, fetchDetailNewsById } from '../../Reducers/actions/newsActions';
import PreviewNews from '../../components/PreviewNews/PreviewNews';
import { getFirstTitleFromHtml } from '../../../helpers/utilities';
import ViewCreationSkeleton from '../ViewCreation/ViewCreationSkeleton';
import { cachingService } from '../../../helpers/cache';
import { setTopNavbar, clearTopNavbar } from '../../Reducers/actions/navbarActions';

const EditNews = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { news_id } = useParams();

  const { view_news, loading, user } = useSelector(state => ({
    view_news: state.news.view_news,
    loading: state.news.loading,
    user: state.auth?.user
  }));

  const [step, setStep] = useState(1);
  const [content, setContent] = useState('');
  const [media_url, setMediaUrl] = useState();
  const [isNotValid, setIsNotValid] = useState(false);
  const [error, setError] = useState('');
  // const [isSaving, setIsSaving] = useState(false);

  // Set the desktop nav title (otherwise it shows the previous screen's title).
  useEffect(() => {
    dispatch(setTopNavbar({ title: 'Edit News', showBackArrow: true }));
    return () => { dispatch(clearTopNavbar()); };
  }, [dispatch]);

  // Fetch the news data when component mounts
  useEffect(() => {
    if (news_id) {
      dispatch(fetchDetailNewsById(news_id));
    }
  }, [dispatch, news_id]);

  // Initialize form data when news is loaded
  useEffect(() => {
    if (view_news) {
      setContent(view_news.content || '');
      setMediaUrl(view_news.media_url);
    }
  }, [view_news]);

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleSave = () => {
    if (media_url) {
      // setIsSaving(true);
      const formData = new FormData();

      // Only append media if it's a new file (not a URL)
      if (media_url instanceof File) {
        formData.append('media', media_url);
      }

      formData.append('title', getFirstTitleFromHtml(content));
      formData.append('content', content);

      fetchUpdateNews(news_id, formData).then((res) => {
        if (res.success) {
          cachingService.invalidate([`/api/news/${user?.user_id}`], true);
          // Navigate back to the previous route
          navigate(-1);
        } else {
          // setIsSaving(false);
          setError('Failed to save news. Please try again.');
        }
      }).catch((err) => {
        console.error('Error updating news:', err);
        // setIsSaving(false);
        setError('Failed to save news. Please try again.');
      });
    } else {
      setIsNotValid(true);
      setError('Please add a thumbnail for your news to save.');
    }
  };

  const handleUploadMedia = (file) => {
    setIsNotValid(false);
    setError(null);
    setMediaUrl(file);
  };
  // Show loading while fetching news data
  if (loading || !view_news) {
    return <ViewCreationSkeleton />;
  }

  return (
    <Fragment>
      <div className='write-container'>
        <div
          className='write-header d-flex aic jcc mx-16'
          style={{
            '--progress': `${(step / 2) * 100}%`
          }}
        >
          <span className='back-icon' onClick={() => step === 2 ? setStep(step - 1) : navigate(-1)}>
            <Icon alias='chevron-left' width={24} color='#0A0F1E' />
          </span>
          <h2 className='fs-sm2 fg-dark fw-bold'>Edit News</h2>
          <button
            className='btn btn-sm red-btn rounded-xl fs-xxs p-fixed px-16'
            style={{ right: '16px' }}
            onClick={step === 1 ? handleNext : handleSave}
            disabled={content?.length === 0}
          >{step === 1 ? "Next" : "Save"}
          </button>
        </div>
      </div>
      {step === 1 ?
        <div className='writer pt-40 mt-40'>
          <NewsEditor value={content} onChange={setContent} />
        </div>
        :
        <div className='preview-news mt-40'>
          <PreviewNews
            classNames='mt-32'
            content={content}
            onUploadMedia={handleUploadMedia}
            isNotValid={isNotValid}
            existingMediaUrl={view_news.media_url}
            type='edit'
          />
          {error && <p className='error'>{error}</p>}
          {/* <button
            className='publish btn red-btn btn-full aic jcc fw-bold mb-16'
            onClick={handleSave}
            disabled={content?.length === 0 || isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button> */}
        </div>}
    </Fragment>
  );
};

export default EditNews; 